import React from "react";


const CastingCharge = () => {


    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                <div className="card">
                    <div className="card-header">
                        <h4 className="card-title mb-0">Casting Charges
                        </h4>
                        <p>A complete guide
                        </p>
                    </div>

                    <div className="card-body">
                        <div className="container mt-4">
                            <h5>A complete guide</h5>
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col">Service</th>
                                        <th scope="col">Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Sprueing</td>
                                        <td>
                                            1 piece – £3.00<br />
                                            2-5 pieces (per job) – £6.00
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Casting charges per gram:</td>
                                        <td>
                                            Platinum – £3.25<br />
                                            Gold 22ct – £3.00<br />
                                            Gold 18ct – £2.80<br />
                                            Gold 14ct – £2.20<br />
                                            Gold 9ct – £2.00
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Small component charge: (Platinum and gold only)</td>
                                        <td>Components under 1g – £0.50 per piece</td>
                                    </tr>
                                    <tr>
                                        <td>Wax from customer own moulds:</td>
                                        <td>£6 per piece</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default CastingCharge;